import React, { forwardRef, memo, useImperativeHandle, useState } from 'react';
import { Space } from 'antd';
import logo from '@/assets/logo.png'

const LoadingView = forwardRef((props, ref) => {

    const [show, setShow] = useState(false)

    useImperativeHandle(ref, () => ({
        views,
    }));

    const views = bol => {
        setShow(bol)
    }

    const letters = [
        { char: 'i', delay: '150ms' },
        { char: 'F', delay: '300ms' },
        { char: 'u', delay: '450ms' },
        { char: 'n', delay: '600ms' },
    ];

    return (
        show &&
        <div className='flex flex-col justify-center items-center w-full h-full absolute z-50 left-0 top-0 right-0 bottom-0 bg-white/70 gap-3'>
            <Space align="center">
                <img
                    src={logo}
                    className="w-20 h-20"
                    style={{
                        animation: 'jump 1s ease-in-out infinite',
                        animationDelay: '0ms',
                    }}
                />
                {
                    letters.map((letter, index) => (
                        <div
                            key={index}
                            className="text-6xl font-extrabold text-cyan-500"
                            style={{
                                animation: 'jump 1s ease-in-out infinite',
                                animationDelay: letter.delay,
                            }}
                        >
                            {letter.char}
                        </div>
                    ))
                }
            </Space>
            <span className='text-xl text-cyan-800'>Loading...</span>
            <style>
                {`
                    @keyframes jump {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(-20px); }
                    }
                `}
            </style>
        </div>
    );
});

export default memo(LoadingView);